'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 13, viewBox: "0 0 12 13", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.99979 10.593C7.98816 10.593 9.60006 8.98108 9.60006 6.99271C9.60006 5.00433 7.98816 3.39243 5.99979 3.39243C4.01141 3.39243 2.39951 5.00433 2.39951 6.99271C2.39951 8.98108 4.01141 10.593 5.99979 10.593ZM5.99979 11.993C8.76136 11.993 11.0001 9.75428 11.0001 6.99271C11.0001 4.23113 8.76136 1.99243 5.99979 1.99243C3.23821 1.99243 0.999512 4.23113 0.999512 6.99271C0.999512 9.75428 3.23821 11.993 5.99979 11.993ZM6 6.44287C6.3866 6.44287 6.7 6.75627 6.7 7.14287V9.05862C6.7 9.44522 6.3866 9.75862 6 9.75862C5.6134 9.75862 5.3 9.44522 5.3 9.05862V7.14287C5.3 6.75627 5.6134 6.44287 6 6.44287ZM5.99999 5.92601C6.4142 5.92601 6.74998 5.59022 6.74998 5.17602C6.74998 4.76181 6.4142 4.42603 5.99999 4.42603C5.58578 4.42603 5.25 4.76181 5.25 5.17602C5.25 5.59022 5.58578 5.92601 5.99999 5.92601Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
